import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/tabs';
import { Shield, Beaker, Clock, Bot, Cpu, LogOut } from 'lucide-react';
import IntegrationsTab from './IntegrationsTab';
import SimulationTools from './SimulationTools';
import TradingScheduleTab from './TradingScheduleTab';
import WarRoomSettingsTab from './WarRoomSettingsTab';
import AIModelSettings from './AIModelSettings';
import ExitStrategyTab from './ExitStrategyTab';

export default function UnifiedSettings() {
  return (
    <div className="p-6 max-w-7xl mx-auto space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-foreground">System Config Hub</h1>
          <p className="text-sm text-muted-foreground">Manage all Titan-X platform settings, integrations, and AI model routing.</p>
        </div>
      </div>

      <Card>
        <CardContent className="p-6">
          <Tabs defaultValue="schedule" className="space-y-6">
            <TabsList className="w-full justify-start h-auto p-1 overflow-x-auto hide-scrollbar">
              <TabsTrigger value="schedule" className="flex items-center gap-2 text-xs py-2">
                <Clock className="w-4 h-4" />
                Trading Schedule
              </TabsTrigger>
              <TabsTrigger value="warroom" className="flex items-center gap-2 text-xs py-2">
                <Bot className="w-4 h-4" />
                War Room
              </TabsTrigger>
              <TabsTrigger value="exit-strategy" className="flex items-center gap-2 text-xs py-2">
                <LogOut className="w-4 h-4" />
                Exit Strategy
              </TabsTrigger>
              <TabsTrigger value="integrations" className="flex items-center gap-2 text-xs py-2">
                <Shield className="w-4 h-4" />
                Integrations &amp; Keys
              </TabsTrigger>
              <TabsTrigger value="ai-models" className="flex items-center gap-2 text-xs py-2">
                <Cpu className="w-4 h-4" />
                AI Models
              </TabsTrigger>
              <TabsTrigger value="simulation" className="flex items-center gap-2 text-xs py-2">
                <Beaker className="w-4 h-4" />
                Simulation
              </TabsTrigger>
            </TabsList>

            <TabsContent value="schedule" className="outline-none">
              <TradingScheduleTab />
            </TabsContent>

            <TabsContent value="warroom" className="outline-none">
              <WarRoomSettingsTab />
            </TabsContent>

            <TabsContent value="exit-strategy" className="outline-none">
              <ExitStrategyTab />
            </TabsContent>

            <TabsContent value="integrations" className="outline-none">
              <IntegrationsTab />
            </TabsContent>

            <TabsContent value="ai-models" className="outline-none">
              <AIModelSettings />
            </TabsContent>

            <TabsContent value="simulation" className="outline-none">
              <SimulationTools />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
}
